module.exports = __webpack_public_path__ + "img/thank.a5b8283e.png";